module.exports = __webpack_public_path__ + "static/media/new1.2f2532f5.png";